export const MINIMUM_SHIFT_PATTERN_DAYS = 1;
export const MAXIMUM_SHIFT_PATTERN_DAYS = 56;
export const MAXIMUM_SHIFT_PATTERN_PER_LINE = 28;